<div class="ui basic segment" style="margin:-45px -20px;" lmsPadding paddingT="5px" paddingX="10">
    <div class="ui stackable grid" appMargin marginT="5px">
        <div style="display:flex;" class="ui column four wide">
          <div style="position:relative;top:8px;cursor:pointer">
              <img (click)="goBack()" src="assets/icons/left-arrow-icon.svg" alt="" />
            </div>
            <div style="margin-left: 15px;" class="equipment-id">
           <h6 style="color:#6D7175;font-weight: 400;font-size: 10px;margin:-15px 0;">Home / Settings/ Application Security</h6>
          <div style="font-weight: 500 !important;margin-bottom:10px;color:#3F4395;" class="ui large header theme-color">Settings</div>
        </div>
      </div>
      
      </div>
      <div class="ui divider"></div>
      <div *ngIf="success || error">
        <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
        <esl-message-toast [(message)]="error"></esl-message-toast>
      </div>


      <div class="body ui" fxLayout="column">

        <div fxLayout="row" fxLayoutGap='15px'>
            <div fxFlex="25%" fxLayout='column' fxLayoutGap='50px'>
                <div>
                    <div class="side-panel">
                        <ng-container *ngFor="let menu of menus">
                            <a class='ui white button'
                                fxLayout='row' (click)="selectMenu(menu.id,menu.name)"
                                [ngClass]="{'primary':selectedMenu == menu.id}"
                                style="text-wrap: nowrap;justify-content: left;" appMargin marginY='8px' appPadding
                                paddingY='14px'>
                                {{menu.name}}
                            </a></ng-container>
                    </div>
                </div>
            </div>
            <div fxFlex="75%">
                <div fxLayout="column">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>
